import { Paper } from "@mui/material";

import { DeliveryTruckIcon, RailroadIcon } from "../../../icons";

import PickerOption from "../../../components/PickerOption";
import { useIsMobile } from "../../../hooks/useIsMobile";

const CAModePicker = ({
  value,
  setValue,
  railType,
  setRailType,
  borderOff,
}: {
  value: string;
  setValue: (value: string) => void;

  railType?: "single" | "85+" | "100+";
  setRailType: (value?: "single" | "85+" | "100+") => void;
  borderOff?: boolean;
}) => {
  const isMobile = useIsMobile(400);
  const select = (mode: string, type?: "single" | "85+" | "100+") => {
    setValue(mode);
    setRailType(type);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ fontSize: 18, fontWeight: 500, paddingLeft: 10 }}>Mode</div>
      <Paper
        style={{
          border: borderOff ? "none" : "1px solid #d9d9d9",
          boxShadow: "none",
          display: "flex",
          justifyContent: "space-around",
          padding: borderOff ? "0px 20px" : "10px 10px",
          borderRadius: 10,
        }}
      >
        <PickerOption
          label="Truck"
          Icon={DeliveryTruckIcon}
          select={() => select("TRUCK")}
          selected={value === "TRUCK"}
          width={80}
          height={60}
          isMobile={isMobile}
        />

        <PickerOption
          label="Single"
          Icon={RailroadIcon}
          select={() => select("RAIL", "single")}
          selected={value === "RAIL" && railType === "single"}
          width={80}
          height={60}
          isMobile={isMobile}
        />

        <PickerOption
          label="85+ UT"
          Icon={RailroadIcon}
          select={() => select("RAIL", "85+")}
          selected={value === "RAIL" && railType === "85+"}
          width={80}
          height={60}
          isMobile={isMobile}
        />

        <PickerOption
          label="100+ UT"
          Icon={RailroadIcon}
          select={() => select("RAIL", "100+")}
          selected={value === "RAIL" && railType === "100+"}
          width={80}
          height={60}
          isMobile={isMobile}
        />
      </Paper>
    </div>
  );
};

export default CAModePicker;
